import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { KalenderAbwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderAbwesenheit';
import { Body, PopoverContent } from '@e2n/ui/v2';

export function MitarbeiterAbwesenheitIntervalContent({
  interval,
  onMouseEnter,
  onMouseLeave,
}: {
  interval: KalenderAbwesenheit;
  onMouseEnter: (event: React.MouseEvent) => void;
  onMouseLeave: () => void;
}) {
  const abwesenheitslaengeInTagen =
    dayjs(interval.abwesenheit.bis)
      .startOf('day')
      .diff(dayjs(interval.abwesenheit.von).startOf('day'), 'day') + 1;

  return (
    <>
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className="w-full h-full bg-neutrals-300 border-neutrals-700 border border-solid rounded-lg flex items-center justify-start px-3">
        {abwesenheitslaengeInTagen >= 2 && (
          <Body className="flex items-center gap-1 min-w-0 truncate" size="sm">
            <FontAwesomeIcon
              className="size-3.5 shrink-0"
              icon={interval.abwesenheit.abwesenheitsgrundIcon}
            />
            {interval.abwesenheit.grund}
          </Body>
        )}
        <PopoverContent className="flex-row items-center justify-between gap-4 px-4 py-3">
          <div className="flex items-center gap-2 min-w-0">
            <FontAwesomeIcon
              className="size-4 text-labels-primary"
              icon={interval.abwesenheit.abwesenheitsgrundIcon}
            />
            <Body className="truncate">{interval.abwesenheit.grund}</Body>
          </div>
          <Body className="whitespace-nowrap">
            {interval.abwesenheit.zeitraumLabel}
          </Body>
        </PopoverContent>
      </div>
    </>
  );
}
